import styled from "styled-components";
import { ContextMenu } from "primereact/contextmenu";

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  // overflow: hidden;
`;

export const TreeBody = styled.div`
  flex: 1;
  // overflow-y: auto;
  position: relative;

  .p-tree {
    border: none;
    background: transparent;
    padding: 0;
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 0;
    padding: 4px 0;
    transition: background 0.15s;
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content:hover {
    background: ${({ theme }) => theme.colors.treeNodeHover};
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
    background: ${({ theme }) => theme.colors.select};
    color: ${({ theme }) => theme.colors.secondary};
    font-weight: 500;
  }

  .p-tree
    .p-tree-container
    .p-treenode
    .p-treenode-content.p-highlight
    .p-tree-toggler,
  .p-tree
    .p-tree-container
    .p-treenode
    .p-treenode-content.p-highlight
    .p-treenode-icon {
    color: ${({ theme }) => theme.colors.secondary};
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
    flex: 0 0 auto;
    margin-right: 8px;
    color: ${({ theme }) => theme.colors.toggleIcon};
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon {
    flex: 0 0 auto;
    margin-right: 6px;
    color: ${({ theme }) => theme.colors.iconSecondary};
  }

  .p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-label {
    min-width: 0;
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.9rem;
  }

  .p-tree .p-tree-filter-container .p-tree-filter {
    width: 100%;
    padding: 8px 12px;
    color: ${({ theme }) => theme.colors.textSecondary} !important;
    border: 1px solid ${({ theme }) => theme.colors.inputBorderMedium} !important;
    border-radius: 6px;
    font-size: 0.85rem;
    transition: border-color 0.15s;
  }

  .pi-circle-fill {
    color: #4caf50 !important;
  }
`;

export const TreeSearchBar = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  position: sticky;
  top: 0;
  z-index: 3;
  padding: 4px 0 8px;
  background-color: ${({ theme }) => theme.colors.menuBackground};

  .p-input-icon-left {
    flex: 1;
    min-width: 0;
  }

  .p-input-icon-left > i {
    color: ${({ theme }) => theme.colors.iconSecondary};
    position: absolute;
    right: 0.75rem;
  }

  .tree-search-input {
    width: 100%;
    padding: 8px 24px 8px 12px;
    color: ${({ theme }) => theme.colors.textSecondary} !important;
    border: 1px solid ${({ theme }) => theme.colors.inputBorderMedium} !important;
    border-radius: 6px;
    font-size: 0.85rem;
    transition: border-color 0.15s;
    background: ${({ theme }) => theme.colors.background} !important;
  }

  .tree-sort-button.p-button {
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    border: 1px solid ${({ theme }) => theme.colors.inputBorder};
    color: ${({ theme }) => theme.colors.textSecondary};
    background: ${({ theme }) => theme.colors.treeNodeHover};
    transition: background-color 0.2s, color 0.2s, box-shadow 0.2s,
      border-color 0.2s;

    &:hover {
      color: ${({ theme }) => theme.colors.iconHover};
      box-shadow: ${({ theme }) => theme.shadow.medium};
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
    }
  }

  .tree-sort-button.p-button:hover,
  .tree-sort-button.p-button.p-button-secondary:enabled:hover {
    background: ${({ theme }) => theme.colors.treeNodeHover};
    border-color: ${({ theme }) => theme.colors.inputBorderMedium};
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const TreeControls = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #e9ecef;
  background: #f8f9fa;

  .p-button {
    border-radius: 6px;
    font-size: 0.8rem;
    padding: 6px 12px;
  }

  .p-button-outlined {
    color: #00527a;
    border-color: #00527a;
  }

  .p-button-outlined:hover {
    background: #e3f0ff;
  }
`;

export const StyledContextMenu = styled(ContextMenu)`
  .p-menuitem-text {
    font-size: 0.9rem;
  }
  .p-menuitem-icon {
    margin-right: 8px;
  }
`;

export const NodeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  width: 100%;
  max-width: 155px;
`;
